export const common = {
  black: '#000000',
  white: '#ffffff',
};
